"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./export_ui"));
var webTransport_1 = require("./shared/modules/webTransport");
exports.webTransport = webTransport_1.webTransport;
var coreAdmin_1 = require("./ui_admin/coreAdmin");
var export_ui_1 = require("./export_ui");
var coreDialog_1 = require("./ui_admin/coreDialog");
var React = require("react");
var ReactDOM = require("react-dom");
var MainLayout_1 = require("./ui_admin/components/MainLayout");
var fileBinaryChunkedUploadCtl_1 = require("./shared/helpers/fileBinaryChunkedUploadCtl");
coreDialog_1.DIALOG.DlgLogout.SetOnYesClick(function () {
    coreAdmin_1.ADMIN.UIState.SetUnLogged();
});
fileBinaryChunkedUploadCtl_1.fileBinaryChunkedReader.init();
export_ui_1.UI.init = function (mountPointId) {
    ReactDOM.render(React.createElement(MainLayout_1.default, null), document.getElementById(mountPointId));
};
//https://habr.com/post/321924/#horoshie-uvedomleniya WEB PUSH API !!!



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin.tsx
// module id = 331
// module chunks = 0